import { render, staticRenderFns } from "./FormTask.vue?vue&type=template&id=b52af460"
import script from "./FormTask.vue?vue&type=script&lang=js"
export * from "./FormTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormTask.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b52af460')) {
      api.createRecord('b52af460', component.options)
    } else {
      api.reload('b52af460', component.options)
    }
    module.hot.accept("./FormTask.vue?vue&type=template&id=b52af460", function () {
      api.rerender('b52af460', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/components/FormTask.vue"
export default component.exports